"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SourceFetcherTokenAndValueSchema = exports.SourceFetcherTokenSchema = exports.SourceFetcherSchema = exports.SourceFetcherResultSchema = exports.AbTestingSchema = exports.MetaDataSchema = exports.OpenRTBSchema = exports.AdIntensitySchema = exports.AdIntensityMidrollLimitsSchema = exports.AdIntensityRollLimitsSchema = void 0;
var zod_1 = require("zod");
var thumbnail_source_1 = require("./thumbnail-source");
var video_source_1 = require("./video-source");
var source_fetcher_1 = require("../source-fetcher");
var fetch_sources_1 = require("./fetch-sources");
var token_value_1 = require("./token-value");
exports.AdIntensityRollLimitsSchema = zod_1.z.object({
    max: zod_1.z.number(),
});
exports.AdIntensityMidrollLimitsSchema = exports.AdIntensityRollLimitsSchema.extend({
    blocks: zod_1.z.array(zod_1.z.object({
        max: zod_1.z.number(),
        position: zod_1.z.number(),
    })),
});
exports.AdIntensitySchema = zod_1.z
    .object({
    preroll: exports.AdIntensityRollLimitsSchema,
    midroll: exports.AdIntensityMidrollLimitsSchema,
    postroll: exports.AdIntensityRollLimitsSchema,
    overlays: zod_1.z.object({ positions: zod_1.z.array(zod_1.z.union([zod_1.z.number(), zod_1.z.string()])) }),
})
    .partial();
exports.OpenRTBSchema = zod_1.z.object({
    id: zod_1.z.string(),
    episode: zod_1.z.number(),
    title: zod_1.z.string(),
    series: zod_1.z.string(),
    season: zod_1.z.string(),
    artist: zod_1.z.string(),
    genre: zod_1.z.string(),
    isrc: zod_1.z.string(),
    url: zod_1.z.string(),
    cat: zod_1.z.union([zod_1.z.string().array(), zod_1.z.string()]),
    prodq: zod_1.z.number(),
    context: zod_1.z.enum(['video', 'game', 'music', 'application', 'text', 'other', 'unknown']),
    contentrating: zod_1.z.string(),
    keywords: zod_1.z.string(),
    livestream: zod_1.z.number(),
    sourcerelationship: zod_1.z.number(),
    len: zod_1.z.number(),
    language: zod_1.z.string(),
});
exports.MetaDataSchema = zod_1.z.object({
    brand: zod_1.z.string(),
    channelId: zod_1.z.number(),
    productPlacement: zod_1.z.boolean(),
});
exports.AbTestingSchema = zod_1.z.object({
    id: zod_1.z.string(),
    group: zod_1.z.string(),
    name: zod_1.z.string(),
    type: zod_1.z.string(),
});
exports.SourceFetcherResultSchema = zod_1.z
    .object({
    error: zod_1.z.object({ name: zod_1.z.string(), message: zod_1.z.string() }),
    sources: zod_1.z.array(video_source_1.VideoSourceSchema),
    thumbnails: zod_1.z.array(thumbnail_source_1.ThumbnailSourceSchema),
    ageRestriction: zod_1.z.number(),
    parentalRatingCategories: zod_1.z.string(),
    addition: zod_1.z
        .object({
        topics: zod_1.z.array(zod_1.z.string()),
    })
        .partial(),
    adIntensity: exports.AdIntensitySchema,
    showProductPlacement: zod_1.z.boolean(),
    openRTB: exports.OpenRTBSchema.partial(),
    metadata: exports.MetaDataSchema.partial(),
    abTesting: exports.AbTestingSchema.partial(),
    wasRequestedWithToken: zod_1.z.boolean(),
})
    .partial();
// do not use for inferring the type
exports.SourceFetcherSchema = zod_1.z.object({
    fetchSources: fetch_sources_1.FetchSourcesSchema,
    setToken: zod_1.z.function(),
    registerTokenCallback: zod_1.z.function(),
});
exports.SourceFetcherTokenSchema = zod_1.z.nativeEnum(source_fetcher_1.SourceFetcherToken);
exports.SourceFetcherTokenAndValueSchema = zod_1.z
    .tuple([exports.SourceFetcherTokenSchema, token_value_1.TokenValueSchema])
    .refine(function (_a) {
    var token = _a[0], value = _a[1];
    var tokenValueType = typeof value;
    return token === source_fetcher_1.SourceFetcherToken.abTestAllowed
        ? tokenValueType === 'boolean'
        : tokenValueType === 'string';
}, function (_a) {
    var token = _a[0];
    return ({
        message: "Wrong combination of token and value. \"".concat(token, "\" should be used with ").concat(token === source_fetcher_1.SourceFetcherToken.abTestAllowed ? 'boolean' : 'string', " value"),
    });
});
//# sourceMappingURL=source-fetcher.js.map